import React from "react"
import styled from "@emotion/styled"
import { injectIntl } from "gatsby-plugin-intl"

const CompositionSectionWrapper = styled.div`
  display: flex;
  background: #1b2a56;
  width: 100%;
  align-items: center;
  color: #fff;
`

const CompositionSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 1200px;
  width: 100%;
  padding: 40px 20px;
  margin: 0px auto;
`

const SectionTitle = styled.h2`
  font-size: 36px;
  font-weight: bold;
  font-family: "BebasNeueBold";
  line-height: 1;
  margin: 0px 0px 20px 0px;
`

const SectionSubTitle = styled.p`
  font-size: 14px;
  font-family: "Museo";
  font-weight: 600;
  line-height: 1.2;
  margin: 0px 0px 20px 0px;
`

const Row = styled.div`
  display: flex;
  width: 100%;
  margin: 0px auto;
  align-items: center;

  @media (max-width: 600px) {
    flex-direction: column;
  }
`

const LeftSection = styled.div`
  width: 100%;
  max-width: 430px;
  display: flex;
  flex-direction: column;
  padding-right: 20px;

  @media (max-width: 600px) {
    max-width: 100%;
  }
`

const RightSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  padding-left: 20px;
  color: #1b2a56;

  @media (max-width: 600px) {
    padding-left: 0px;
  }
`

const ImageWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`

const Image = styled.img`
  width: 100%;
  margin: 0px;
  object-fit: contain;
`

const CompositionSliderWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
`

const Card = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  margin: 0px;
  flex-basis: 50%;
  width: 50%;
  padding: 10px 0px;
  max-width: 200px;

  :nth-of-type(odd) {
    padding-right: 10px;
  }

  :nth-of-type(even) {
    padding-left: 10px;
  }
`

const IconImage = styled.img`
  width: 100%;
  max-width: 40px;
  margin: 0px 10px 0px 0px;

  @media (max-width: 380px) {
    max-width: 30px;
    margin: 0px 7px 0px 0px;
  }
`

const Text = styled.p`
  font-size: 12px;
  font-weight: bold;
  font-family: "Gotham Book";
  line-height: 1.1;
  margin: 0px;
`

const SommiersTechnologySection = ({ intl, data }) => {
  return (
    data && (
      <CompositionSectionWrapper>
        <CompositionSectionContainer>
          <Row>
            <LeftSection>
              {data.section_title && (
                <SectionTitle
                  dangerouslySetInnerHTML={{
                    __html: data.section_title,
                  }}
                />
              )}
              {data.section_subtitle && (
                <SectionSubTitle
                  dangerouslySetInnerHTML={{
                    __html: data.section_subtitle,
                  }}
                />
              )}
              {data.list && (
                <CompositionSliderWrapper>
                  {data.list.map((item, index) => {
                    return (
                      item &&
                      item.image &&
                      item.text && (
                        <Card key={index.toString()}>
                          <IconImage
                            src={item.image}
                            alt={item.alt ? item.alt : ""}
                          />
                          <Text
                            dangerouslySetInnerHTML={{
                              __html: item.text,
                            }}
                          />
                        </Card>
                      )
                    )
                  })}
                </CompositionSliderWrapper>
              )}
            </LeftSection>
            <RightSection>
              {data.image && (
                <ImageWrapper>
                  <Image src={data.image} alt={data.alt ? data.alt : ""} />
                </ImageWrapper>
              )}
            </RightSection>
          </Row>
        </CompositionSectionContainer>
      </CompositionSectionWrapper>
    )
  )
}

export default injectIntl(SommiersTechnologySection)
